import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('authUser');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  function persistSession(token, nextUser) {
    localStorage.setItem('authToken', token);
    localStorage.setItem('authUser', JSON.stringify(nextUser));
    setUser(nextUser);
  }

  async function login(email, password) {
    const { token, user: loggedInUser } = await api.post('/api/auth/login', { email, password });
    persistSession(token, loggedInUser);
    return loggedInUser;
  }

  async function register(name, email, password) {
    const { token, user: newUser } = await api.post('/api/auth/register', { name, email, password });
    persistSession(token, newUser);
    return newUser;
  }

  function logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUser');
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
